<div class="container">
  <h4>Questionário para Avaliação de Eficiência Energética - FGEnergia</h4>

  <div class="row">
    <div class="col-md-12 text-muted mb-5 mt-5"> 
      <p>
        As operações a serem garantidas pelo FGEnergia visam apoiar projetos e ações para eficientização de usos finais de energia elétrica, por meio de substituição de equipamentos existentes por outros mais eficientes ou por meio de mudanças do processo produtivo para otimizar a utilização dos insumos energéticos, emprego de novos procedimentos, tecnologias ou gestão da energia.
      </p>

      <p>
        Serão aceitos projetos de Geração de Energia de Fonte Renovável, desde que contemplem, pelo menos, uma ação de redução/eficientização do consumo de energia. Não serão aceitos projetos cuja única finalidade seja a instalação de sistema de geração distribuída de energia e/ou armazenamento por baterias.
      </p>
      
      <p>
        O questionário de avaliação de eficiência energética está dividido em três blocos, sendo um bloco para identificação da empresa tomadora do crédito e dois blocos de perguntas sobre o projeto de eficiência energética para o qual a empresa está pleiteando financiamento.
      </p>
      
      <p>
        O objetivo do questionário é avaliar, com base nas respostas fornecidas, se o projeto é elegível à garantia no âmbito do FGEnergia.
      </p>

      <p>
        Se depois de preenchidas as perguntas o projeto for considerado elegível, o questionário deverá ser assinado pelo responsável técnico qualificado (engenheiro, técnico em eletrotécnica ou profissional certificado) e pelo representante da empresa tomadora do crédito atestando a veracidade das informações prestadas. Somente com esse questionário preenchido e assinado que os agentes financeiros habilitados a operar com o FGEnergia conseguem solicitar a garantia.
      </p>

      <p>
        Importante mencionar que a aprovação do questionário não garante o financiamento ou a garantia. A decisão de conceder o financiamento depende do Agente Financeiro.
      </p>
     
    </div>
  </div>

  <div class="row">
      <div class="col-md-4 d-flex align-items-stretch"> 
        <div class="card">
          <div class="card-body d-flex flex-column">
            <h5 class="card-title">Novo Questionário</h5>
            <p class="card-text">Preencha o Questionário de Avaliação de Eficiência Energética para utilizar a garantia do FGEnergia.</p>
            <div class="text-end flex-grow-1">
              <div class="d-flex flex-column justify-content-end h-100">
                <button class="btn btn-primary" (click)="novoQuestionario()">
                  Preencher Questionário
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-body d-flex flex-column">
            <h5 class="card-title">Continue o Preenchimento</h5>
            <p class="card-text">Informe o número do rascunho e clique em Acessar Rascunho.</p>
            <div class="flex-grow-1">
                <div class="d-flex flex-column justify-content-end h-100">
                  <div class="row">
                      <div class="col-md-12">
                        <label for="cnpjRascunho">CNPJ</label>
                        <input  type="text" class="form-control" 
                                name="cnpjRascunho" [(ngModel)]="cnpjRascunho" placeholder="CNPJ"
                                bnMask="CNPJ" id="cnpj_rascunho">
                      </div>
                  </div>
                  <div class="row mt-2 padding-left-0">
                      <div class="col-md-12">
                        <label for="idRascunho">Numero Rascunho</label>
                        <input  type="text" class="form-control" id="idRascunho"
                                name="numeroRascunho" [(ngModel)]="numeroRascunho" 
                                placeholder="Numero Rascunho">                      
                      </div>
                  </div>                
                  <button class="btn btn-primary mt-3" (click)="carregarRascunho()">
                    Acessar Rascunho    
                  </button>
                </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-body d-flex flex-column">
              <h5 class="card-title">Consulte Questionários Submetidos</h5>
              <p class="card-text">Consulte um questionário já enviado utilizando o código de validação gerado.</p>
              <div class="flex-grow-1">
                <div class="d-flex flex-column justify-content-end h-100">
                  <div class="row">
                      <div class="col-md-12">
                          <label for="cnpjToken">CNPJ</label>
                          <input  type="text" class="form-control" 
                                  name="cnpjToken" [(ngModel)]="cnpjToken" placeholder="CNPJ"
                                  bnMask="CNPJ" id="cnpjToken">
                      </div>
                  </div>
                  <div class="row mt-2 padding-left-0">
                      <div class="col-md-12">
                          <label for="codigoValidacao">Código de Validação</label>
                          <input  type="text" class="form-control" name="token" id="codigoValidacao"
                                  [(ngModel)]="token" placeholder="Código de Validação">
                      </div>
                  </div>
                  <button class="btn btn-primary mt-3" (click)="carregarToken()">
                      Acessar Questionário
                  </button>                
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div>
  </div>
</div>
